import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { forkJoin, Subject, throwError, timer } from 'rxjs';
import { DialogService } from '../_services/dialog.service';
import { NetworkSyncModalComponent } from './networksync-modal.component';
import { AuthService } from '../_services/auth.service';
import { NetworkSyncService } from '../_services/network-sync.service';
import { EngineService } from '../_services/engine.service';
import { delayWhen, retryWhen, tap } from 'rxjs/operators';

@Component({
  selector: 'app-network-sync',
  templateUrl: './networksync.component.html',
  styleUrls: ['./networksync-modal.component.css']
})

export class NetworkSyncComponent {

  @Input()
  public serviceId;

  @Input()
  public viewRef;

  @Input()
  public controllerPath;

  @Input()
  public serviceName;

  @Input()
  public displayCountdown;

  @Output()
  public showSpinner = new EventEmitter<boolean>();

  @Output()
  public spinnerMessage = new EventEmitter<string>();

  public showNetworkSync = false;

  public maxRetries = 3;
  public retries = 0;

  private _onDestroy$: Subject<void> = new Subject();

  private bsModalRef: BsModalRef;

  public modalShowing = false;

  constructor(
    private dialogService: DialogService,
    private modalService: BsModalService,
    private networkSyncService: NetworkSyncService,
    engineService: EngineService,
    authService: AuthService
    ) {
      forkJoin([
        authService.checkFeatureFlag('NetworkSync'),
        authService.getCurrentUser(),
        engineService.hasServiceType('NetworkSync')
      ])
      .subscribe(data => {
        const user = data[1];
        if (user) {
          this.showNetworkSync = data[0] && user.enableNetworkSync && data[2];
        }
      });
    }

  public showNetworkSyncModal() {

    this.showSpinner.emit(true);
    this.spinnerMessage.emit('Connecting to the Global Sync network, please wait...');

    this.networkSyncService.testBrokerConnection()  
      .pipe(
        retryWhen(errors => errors.pipe(
          tap(errorCode => {

            this.retries++;

            console.log('Error: retries ' + this.retries);

            if (this.retries === 1) {

              this.spinnerMessage.emit('Looks like Global Sync is experiencing heavy traffic, please wait...');

            } else if (this.retries >= 2 && this.retries < this.maxRetries) {

              this.spinnerMessage.emit('We\'re still working on it, please continue to wait...');

            } else {

              throwError(errorCode);
            }          
          }),
          delayWhen(() => timer(2000))
        ))
      )
      .subscribe(
        () => {

          this.showSpinner.emit(false);
          this.spinnerMessage.emit('');

          this.modalShowing = true;

          const modalConfig = {
            backdrop: true,
            ignoreBackdropClick: true
          };

          const initialState = {
            serviceId: this.serviceId,
            controllerPath: this.controllerPath,
            displayCountDown: this.displayCountdown
          };

          this.bsModalRef = this.modalService
            .show(
              NetworkSyncModalComponent,
              Object.assign({}, modalConfig, { class: 'modal-md', initialState }));

          this.bsModalRef.content.hasError.subscribe(
            value => {
              if (value) {
                this.bsModalRef.content.errorMessage.subscribe(message => {
                  this.dialogService.alert(
                    'Unable to start Global Sync',
                    'Please check your internet connection, and try again in a few moments. If you continue to see this message, please contact us at support@connectwithcue.com. We apologize for the inconvenience. ' + message,
                    this.viewRef);
                });
              }
              this.modalShowing = false;
          });

          if (!this.displayCountdown) {
            this.bsModalRef.content.published.subscribe(
              value2 => {
                if (value2) {
                  this.dialogService.alert(
                    'Success!',
                    'Your service has been published',
                  this.viewRef);
                }
                this.modalShowing = false;
              });
          }
        },
        (error) => {

          this.showSpinner.emit(false);
          this.spinnerMessage.emit('');

          this.dialogService.error(
            error,
            'Please check your internet connection, and try again in a few moments. If you continue to see this message, please contact us at support@connectwithcue.com. We apologize for the inconvenience',
            this.viewRef); 
        });            
  }
}
